module.exports = __webpack_public_path__ + "media/images/lb/115-842db922db95606518819558ae6eba83.svg";